import { Directive, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { ImmomioIconName } from '../../models';

@Directive()
export class PasswordCheckBaseComponent {
  @Input() controller: AbstractControl;
  @Input() className: string;
  protected readonly immomioIconName = ImmomioIconName;
}
